//一些公用的方法

import {getCommunal} from '@/api/common'
import wx from 'weixin-js-sdk'
/**
 * @author IvanCai
 * @description 此工具类请放置一些常用操作函数，如字符操作，存取cookie等
 */
export default {

	getCookie(cname) {
		const name = `${cname}=`;
		const cookies = document.cookie.split(';');

		for (let i = 0; i < cookies.length; i += 1) {
			const cookie = cookies[i].trim();
			if (cookie.indexOf(name) === 0) {
				return cookie.substring(name.length, cookie.length);
			}
		}
		return '';
	},

  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  setCookie(cname, cvalue, exdays, path = '/') {
    const date = new Date();

    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);

    const expires = `expires=${date.toGMTString()}`;

    document.cookie = `${cname}=${cvalue}; ${expires}; path=${path}`;
    console.log(document.cookie, '设置后的cookie');
    sessionStorage.setItem("X-Access-Token",`${cvalue}`);
  },


	setSession(key, value){
		if (typeof value === 'string') {
			sessionStorage.setItem(key, value);
		} else {
			sessionStorage.setItem(key, JSON.stringify(value));
		}
	},

	getSession(key, isObj){
		var data = sessionStorage.getItem(key);
		if (isObj) { // 是否是对象
			return JSON.parse(data);
		} else {
			return data;
		}
	},

	removeSession(key){
		sessionStorage.removeItem(key);
	},
  //小数点保留2位
  handleDecimals (num) {
    let re = /([0-9]+\.[0-9]{2})[0-9]*/;
    let newNum = num.toString().replace(re,"$1");
    if(!newNum) return '';
    return Number(newNum);
	},

	//获取参数
	handleUrl(url) {
		let decodedUrl = decodeURI(url);
		let query = decodedUrl.split('?')[1];
		let queryObj = {};
		if (query) {
			let queryArr = query.split('&');
			queryArr.forEach(item=> {
			 	let itemArr = item.split('=');
			 	queryObj[itemArr[0]] = itemArr[1];
			 })
		}
		return queryObj;
	},
  //判断token是否在有效期内
  judgeExpiry(date) {
     let curTime = new Date();
     let expiryTime = new Date(date);
     if (curTime > expiryTime) {
      //失效
       return true
     } else {
      return false
     }
  },
	
	typeToName(type){
		var code={
			"1"	:'除处理费用外，商家还同意消费者申请退货退款',
			"2" :'除处理费用外，商家还愿意额外支付消费者补偿款',
			"3"	:'除处理费用外，商家还同意消费者不退货仅退款',
			"4"	:'其他'
		}
		return code[type] || ""
	},
	
	// 订单状态转换
	statusToName(type){
		var code={
			"1"	:'待付款',
			"2"	:'待处理',
			"3"	:'处理中',
			"4"	:'待确认',
			"5" :"已完成",
			"6" :"已撤单",
			"7" :"已取消",
			"8" :"已驳回",
			"9" :"已退款",
			"10" :"退款中",
			"11" :"未解决",
            "13" :"已撤回"
		}
		return code[type] || ""
	},
	
	// 业务员端订单状态转换
	statusToNameSale(type){
		var code={
			"2"	:'待处理',
			"3"	:'处理中',
			"4"	:'等待客户确认',
			"5" :"订单已完成",
			"6" :"已发起撤单",
			"8" :"客户已驳回订单",
			"9" :"订单已关闭",
		}
		return code[type] || ""
	},
	
	// 管理员端订单状态转换
	statusToNameAdmin(type){
		var code={
			"2"	:'待处理',
			"3"	:'处理中',
			"4"	:'等待客户确认',
			"5" :"订单已完成",
			"6" :"订单已撤单",
			"8" :"订单已驳回",
			"9" :"订单已退款",
		}
		return code[type] || ""
	},
	
	statusToType(type){
		var code={
			"1"	:'提现审核中',
			"2"	:'提现已成功',
			"3"	:'提现已拒绝',	
		}
		
		return code[type] || ""
	},
	
	isMobile(){
		var u = navigator.userAgent;
		if(u.match(/MicroMessenger/i) == 'MicroMessenger'){
		    return 3
		}else{
			if(u.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
				return 1
			}else{
				return 2
			}
		}       
	},
	isWxMin(){
		wx.miniProgram.getEnv(function (res) {
			if (res.miniprogram ) {

			}
		});
	},
	// 点击复制
	copyText(val){
		let oInput = document.createElement("input");
		oInput.setAttribute('value', val)
		oInput.unselectable="on";
		oInput.οnfοcus="this.blur()";
		oInput.style.opacity = "0";
		oInput.style.zIndex = "-10";
		oInput.style.position = "absolute";
		oInput.style.left = "0";
		oInput.style.top = "0";
		document.body.appendChild(oInput);
		oInput.select(); // 选择对象
		oInput.setSelectionRange(0,val.length); //兼容ios-safari核心代码
		document.execCommand("Copy"); // 执行浏览器复制命令
		document.body.removeChild(oInput)
		window.toast("复制成功","txt");
	},
	
	getJsApiconfig(ajaxUrl){
	    axios.get(ajaxUrl, {  //params参数必写 , 如果没有参数传{}也可以
	        params: {url: window.location.href}
	    })
	    .then(function(res){ console.log(res.data);
	        var data = res.data;
	        if(data.status == "0"){
	            wx.config({
	                debug: false,
	                appId: data.data.appId,
	                timestamp: "" + data.data.timestamp,
	                nonceStr: data.data.nonceStr,
	                signature: data.data.signature,
	                jsApiList: [
	                    'checkJsApi',
	                    'onMenuShareTimeline',
	                    'onMenuShareAppMessage',
	                    'onMenuShareQQ',
	                    'onMenuShareWeibo',
	                    'hideMenuItems',
	                    'showMenuItems',
	                    'hideAllNonBaseMenuItem',
	                    'showAllNonBaseMenuItem',
	                    'translateVoice',
	                    'startRecord',
	                    'stopRecord',
	                    'onRecordEnd',
	                    'playVoice',
	                    'pauseVoice',
	                    'stopVoice',
	                    'uploadVoice',
	                    'downloadVoice',
	                    'chooseImage',
	                    'previewImage',
	                    'uploadImage',
	                    'downloadImage',
	                    'getLocalImgData',
	                    'getNetworkType',
	                    'openLocation',
	                    'getLocation',
	                    'hideOptionMenu',
	                    'showOptionMenu',
	                    'closeWindow',
	                    'scanQRCode',
	                    'chooseWXPay',
	                    'openProductSpecificView',
	                    'addCard',
	                    'chooseCard',
	                    'openCard'
	                ]
	            });
	        }else{
	            console.log("页面加载失败，请刷新");
	        }
	    });
	}
};

